import * as React from 'react';

import { AdTypes } from '@xing-com/crate-common-graphql-types';

import { useAds } from '../hooks/use-ads';
import type { AdsContext as Context } from '../types';

type AdsProviderProps = {
  adCount?: number;
  adTypes?: AdTypes[];
  channel: string;
  context?: React.Context<Context>;
  isLoggedOut?: boolean;
};

// Our wrapper to use an "AdsContext"
export const AdsProvider: React.FC<
  React.PropsWithChildren<AdsProviderProps>
> = ({
  children,
  // How many ads to request.
  adCount = 6,
  // What types of ads to request.
  adTypes = [AdTypes.WebsiteAd, AdTypes.VideoAd],
  // The ad channel.
  channel,
  // Fallback to default Context
  context = React.createContext<Context>({
    ads: [],
    isCompleted: false,
  }),

  // logged out ad placements
  isLoggedOut = false,
}) => {
  // Grab the ads via useAds hook.
  const { isCompleted, ads } = useAds({
    adCount,
    adTypes,
    channel,
    isLoggedOut,
  });

  return (
    <context.Provider
      value={{
        ads,
        isCompleted,
      }}
    >
      {children}
    </context.Provider>
  );
};
